import React, { memo } from 'react';
import { motion } from 'framer-motion';
const situations = [{
  emoji: '😱',
  title: '¿Las comidas son una guerra constante?',
  description: 'Fideos, milanesas, galletitas... siempre lo mismo porque es lo único que acepta',
  borderColor: 'border-l-orange-500',
  bgHover: 'hover:bg-orange-50',
  titleColor: 'text-orange-600'
}, {
  emoji: '🧠',
  title: '¿Te preocupa que no esté creciendo bien?',
  description: <>
        El rechazo a las verduras puede causarle anemia,{' '}
        <strong data-id="element-372">
          retraso en el crecimiento, problemas de memoria y de desarrollo
          cerebral
        </strong>
      </>,
  borderColor: 'border-l-violet-500',
  bgHover: 'hover:bg-violet-50',
  titleColor: 'text-violet-600'
}, {
  emoji: '🥗',
  title: '¿Comprás verduras que terminan pudriéndose en la heladera?',
  description: 'Las comprás con esperanza pero terminás cocinando lo de siempre',
  borderColor: 'border-l-emerald-500',
  bgHover: 'hover:bg-emerald-50',
  titleColor: 'text-emerald-600'
}, {
  emoji: '🏥',
  title: '¿La pediatra te dice que "tiene que comer mejor"?',
  description: 'Pero nadie te explica CÓMO lograrlo sin que sea un drama familiar',
  borderColor: 'border-l-orange-400',
  bgHover: 'hover:bg-orange-50',
  titleColor: 'text-orange-500'
}, {
  emoji: '😢',
  title: '¿Te sentís culpable cada vez que le das "comida chatarra"?',
  description: 'Sabés que no es lo ideal pero es lo único que come sin llorar',
  borderColor: 'border-l-violet-400',
  bgHover: 'hover:bg-violet-50',
  titleColor: 'text-violet-500'
}];
export function SituationsSection() {
  return <section className="pt-10 pb-10 bg-white" data-id="element-373">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-374">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-extrabold text-violet-600 text-center mb-12" data-id="element-375">
          ¿Te sentís identificada con alguna de estas situaciones?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-376">
          {situations.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          scale: 1.03,
          transition: {
            type: 'spring',
            stiffness: 300,
            damping: 20
          }
        }} className={`bg-gray-50 rounded-2xl p-6 border-l-4 ${item.borderColor} ${item.bgHover} shadow-sm cursor-default transition-colors duration-300`} data-id="element-377">
              <span className="text-4xl mb-4 block" data-id="element-378">{item.emoji}</span>
              <h3 className={`font-extrabold text-lg mb-3 leading-snug ${item.titleColor}`} data-id="element-379">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-380">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}